module.exports = __webpack_public_path__ + "media/images/icons/lightbulb-light-17adf564e9d398621af07d56a444e746.svg";